// extracted by mini-css-extract-plugin
export default {"font-renta":"SkipInspectionModal_font-renta__hGit3","warning":"SkipInspectionModal_warning__7boiH"};